'use strict';

function GarageComplex (item) {
  this.id = item.get('id');
  this.name = item.get('name');
  this.fullName = item.get('fullName');

  this.typeName = 'Гаражный кооператив';
  this.typeShortName = 'ГК';
}

GarageComplex.TYPE_SHORT = 'short';
GarageComplex.TYPE_FULL = 'full';

GarageComplex.prototype.getId = function () {
  return this.id;
};

GarageComplex.prototype.getUri = function () {
  return false;
};

GarageComplex.prototype.getName = function () {
  return this.name;
};

GarageComplex.prototype.getFullName = function () {
  return this.fullName;
};

GarageComplex.prototype.getLabel = function (type = GarageComplex.TYPE_SHORT) {
  const name = this.getFullName() || this.getName();

  if (type === GarageComplex.TYPE_SHORT) {
    return name;
  }

  const typeName = type === GarageComplex.TYPE_FULL
      ? this.getType()
      : this.getTypeShort();

  return typeName + '\u00A0\u00AB' + name + '\u00BB';
};

GarageComplex.prototype.getType = function () {
  return this.typeName;
};

GarageComplex.prototype.getTypeShort = function () {
  return this.typeShortName;
};

export default GarageComplex;



// WEBPACK FOOTER //
// ./src/classes/announcement/garageComplex.js